var lib_core = require("lib-core");
var editor_2d = require("editor-2d");
var cio_datamodel = require("cio-datamodel");

var SymbolTerminalToolStateMachine = function (root, editorModel, selectionModel, getDataCollection, options){
    this.root = root;
    this.getDataCollection = getDataCollection;
    this.options = options;

    this.lastRotate = 0;

    editor_2d.PlacingStateMachine.call(this, root, editorModel, selectionModel, this.options.multiplePlacing);
};

lib_core.inherit(SymbolTerminalToolStateMachine, editor_2d.PlacingStateMachine);

module.exports = SymbolTerminalToolStateMachine;

SymbolTerminalToolStateMachine.prototype.createElement = function (startCoord) {
    var terminalNames = this.root.data.terminalNames;    // TODO: maybe also pass this from the manifest

    var terminal = new cio_datamodel.SymbolTerminalData(startCoord, 0, terminalNames.getProposal());
    terminal.addTo(this.getDataCollection());

    var interactionModel = this.editorModel.interactionModelDataMap.get(terminal);

    // TODO: find another way to do this! since the onchange handler will exist on each and every terminal.
    // apply last saved rotation to newly placed terminal
    // interactionModel.rotate(self.lastRotate, interactionModel.pos());
    // interactionModel.data.angle.onChange("interaction_model_coupling_reverse", function () {
    //     self.lastRotate = interactionModel.data.angle();
    // }, 10);

    return interactionModel;
};

